import Axios from 'axios'

import { ENV_CONFIG } from '../config/env'

let authorizationHeader

const globalClient = Axios.create({
  baseURL: ENV_CONFIG.ENGINE_URI,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
})

export function setAccessToken(token) {
  authorizationHeader = `Bearer ${token}`
  globalClient.defaults.headers.Authorization = authorizationHeader
}

export async function fetcher(url): Promise<any> {
  const response = await globalClient.get(url)
  return response.data
}
